import { Suspense, useEffect, useContext, useMemo, useCallback, useState } from "react";
import { Paper } from "@mui/material";
import { useHistory, useLocation } from "react-router-dom";
import { CustomFormDialogType } from "../../../../../../types/components/dialogProps.types";
import PlanHeader from "../../../../../shared/enrollment/planCode/PlanHeader";
import { LazyBrandingActions, LazyCustomFormDialog, LazyPlanBranding } from "../../../../../shared";
import { BBIGSTDBrandingV2, BBIHelpingOurOwnV2, HealthBenefitBanner } from "../../../../../../assets";
import { BrandingProps, BrandingPropsV2 } from "../../../../../../types/components/enrollmentProps.types";
import { AuthContext } from "../../../../../../contexts";
import {
	CommonDetails,
	EnrollmentSchema,
	HOOEnrollment as HOOEnrollmentPayload,
	StandardDetails
} from "../../../../../../types/enrollment.types";
import { generateGstdWaiveEnrollmentPayload } from "../../../../../../utils/commonFunctions/groupEnrollment/enrollment";
import { api } from "../../../../../../utils/api";
import { AddEnrollmentPayload } from "../../../../../../utils/api/enrollment/enrollment";
import { trackPromise } from "react-promise-tracker";
import { Plan } from "../../../../../../types/plan.types";
import { BBI_PLAN_NAMES } from "../../../../../../constants/plan";
import { getCurrentDate } from "../../../../../../utils/commonFunctions/date";

const HOOBranding = ({
	status,
	openEnrollment,
	getEnrollmentInitData,
	alwaysOpenEnrollments,
	planName,
	changePlanProps
}: BrandingPropsV2) => {
	// console.log("changePlanProps====>", changePlanProps.handleChangePlanButtonClick);
	const [waiveReason, setWaiveReason] = useState("");
	const { member } = useContext(AuthContext);
	const location = useLocation();
	const history = useHistory();
	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
	const [HOOEnrollment, setHOOEnrollment] = useState<EnrollmentSchema | null>(null);
	const [premiumAmount, setPremiumAmount] = useState<string | null>("0.0");
	const [deductionStatus, setDeductionStatus] = useState<"CURRENT DEDUCTION" | "PENDING APPROVAL" | "WAIVED" | null>(
		null
	);

	const handleWaiveReasonChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;
		setWaiveReason(value);
	};

	const [customFormDialogProps, setCustomFormDialogProps] = useState<CustomFormDialogType>();
	const { handleChangePlanButtonClick, buttonCaption } = changePlanProps;
	const [alwaysOpenEnrollment, setAlwaysOpenEnrollment] = useState<Plan | null>(null);

	const findPlanAlwaysOpenEnrollment = useCallback(() => {
		if (!alwaysOpenEnrollments?.length) return;
		for (
			let alwaysOpenEnrollmentIdx = 0;
			alwaysOpenEnrollmentIdx < alwaysOpenEnrollments?.length;
			alwaysOpenEnrollmentIdx++
		) {
			const _alwaysOpenEnrollment = alwaysOpenEnrollments[alwaysOpenEnrollmentIdx];
			if (_alwaysOpenEnrollment.plan_name === planName) {
				setAlwaysOpenEnrollment(_alwaysOpenEnrollment);
				break;
			}
		}
	}, [alwaysOpenEnrollments, planName]);

	// const handleWaiveEnrollment = useCallback(async () => {
	// 	if (member === null || openEnrollment === null) {
	// 		return;
	// 	}
	// 	const { standardDetails, commonDetails } = generateGstdWaiveEnrollmentPayload(
	// 		member,
	// 		openEnrollment,
	// 		waiveReason
	// 	);
	// 	const enrollmentPayload: AddEnrollmentPayload = {
	// 		standard_details: standardDetails,
	// 		common_details: commonDetails
	// 	};
	// 	const response = await trackPromise(api.enrollment.addEnrollment(enrollmentPayload));
	// 	if (response) {
	// 		getEnrollmentInitData(false);
	// 	}
	// }, [getEnrollmentInitData, member, openEnrollment, waiveReason]);

	const handleWaiveEnrollment = useCallback(async () => {
		if (!member && !premiumAmount) {
			return;
		}

		const HOOEnrollmentPayload: HOOEnrollmentPayload = {
			location_number: member.location_number,
			location_name: member.location.location_name,
			group_number: member.group_number,
			group_name: member.group.name,
			plan_object_id: alwaysOpenEnrollment ? alwaysOpenEnrollment._id : "",
			plan_code: alwaysOpenEnrollment ? alwaysOpenEnrollment.plan_code : "",
			plan_name: alwaysOpenEnrollment ? alwaysOpenEnrollment.plan_name : "",
			insured_object_id: member._id,
			insured_SSN: member.SSN,
			enrollment_status: "WAIVED",
			waive_reason: "",
			enrollment_date: getCurrentDate(),
			premium_amount: Number(premiumAmount)
		};
		const _HOOEnrollment = await api.enrollment.addNonOEEnrollment(HOOEnrollmentPayload);
		setHOOEnrollment(Object.assign({}, _HOOEnrollment));
		// 	if (_HOOEnrollment) {
		// 		alert("Your enrollment has successfully waived");
		// 	}
		// }, [member, premiumAmount]);
		if (_HOOEnrollment) {
			getEnrollmentInitData(false);
		}
		const step = urlSearchParams.get("step");
		history.push(`?step=${step}&stage=2`);
	}, [getEnrollmentInitData, history, member, urlSearchParams, alwaysOpenEnrollment]);

	const handleWaiveButtonClick = useCallback(() => {
		// if (status.openEnrollment === "CLOSED") {
		// 	alert("Enrollment has not been opened for this plan");
		// 	return;
		// }
		setCustomFormDialogProps(
			Object.assign({}, customFormDialogProps, {
				openDialog: true,
				title: "Are you sure want to waive this enrollment?",
				textfields: [
					{
						label: "Waive Reason",
						onChange: handleWaiveReasonChange,
						value: waiveReason,
						placeholder: "Enter your reason for waive"
					}
				],
				actions: [
					{
						label: "Cancel",
						callback: () =>
							setCustomFormDialogProps(Object.assign({}, customFormDialogProps, { openDialog: false }))
					},
					{
						label: "Yes",
						callback: () => {
							setCustomFormDialogProps(
								Object.assign({}, customFormDialogProps, {
									openDialog: false
								})
							);
							handleWaiveEnrollment();
						}
					}
				]
			})
		);
	}, [customFormDialogProps, handleWaiveEnrollment, status.openEnrollment, waiveReason]);

	const handleEnrollButtonClick = useCallback(() => {
		// if (status.openEnrollment === "CLOSED") {
		// 	alert("Enrollment has not been opened for this plan. ");
		// } else {
		const step = urlSearchParams.get("step");
		history.push(`?step=${step}&stage=1`);
		// }
	}, [history, urlSearchParams, status]);

	const getPremiumAmount = useCallback(() => {
		if (HOOEnrollment) {
			const { premium_amount, enrollment_status } = HOOEnrollment;
			if (enrollment_status === "ACTIVE") {
				setPremiumAmount(premium_amount + "");
				setDeductionStatus("CURRENT DEDUCTION");
			} else if (enrollment_status === "SUBMITTED") {
				setPremiumAmount(premium_amount + "");
				setDeductionStatus("PENDING APPROVAL");
			} else if (enrollment_status === "WAIVED") {
				setPremiumAmount("0.00");
				setDeductionStatus("WAIVED");
			} else {
				setPremiumAmount("0.00");
				setDeductionStatus(null);
			}
			// if (enrollment_status === "WAIVED") {
			// 	setShowWaiveEnrollmentButton(false);
			// } else {
			// 	setShowWaiveEnrollmentButton(true);
			// }
		}
	}, [HOOEnrollment]);
	useEffect(() => {
		getPremiumAmount();
	}, [HOOEnrollment, getPremiumAmount]);

	useEffect(() => {
		findPlanAlwaysOpenEnrollment();
	}, [findPlanAlwaysOpenEnrollment]);

	// console.log("custom", customFormDialogProps);

	return (
		<div className="paper-form-container">
			<Suspense fallback={<div />}>
				{customFormDialogProps ? <LazyCustomFormDialog customFormDialogProps={customFormDialogProps} /> : null}
			</Suspense>
			<Paper className="theme-border-radius paper-container" elevation={1}>
				{alwaysOpenEnrollment ? (
					<PlanHeader planName={alwaysOpenEnrollment?.plan_name} planCode={alwaysOpenEnrollment?.plan_code} />
				) : null}
				<div className="theme-plan-section-margin" />
				<Suspense fallback={<div />}>
					{/* <LazyPlanBranding imgSrc={HealthBenefitBanner} /> */}
					<LazyPlanBranding imgSrc={BBIHelpingOurOwnV2} />
				</Suspense>
				<Suspense fallback={<div />}>
					<LazyBrandingActions
						waiveButtonCallback={handleWaiveButtonClick}
						enrollButtonCallback={handleEnrollButtonClick}
						handleChangePlanButtonClick={handleChangePlanButtonClick}
						buttonCaption={buttonCaption}
						planNameIndicator={BBI_PLAN_NAMES.helping_our_own}
					/>
				</Suspense>
			</Paper>
		</div>
	);
};

export default HOOBranding;
